import * as detect from '../browser-detect'

/**
 * Function to detect Javascript features
 * @param {...string} args The list of Javascript tests
 */
export function all (...args) {
  return detect.all(...args)
}
